module.exports = __webpack_public_path__ + "static/media/test-pencil.57c2245c.jpg";